import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { appConfig } from '../../config/app';

const HeroVideoSection = () => {
  const [isMuted, setIsMuted] = useState(true);

  // Convert YouTube Shorts URL to embed format with autoplay and loop
  const getEmbedUrl = (url, muted = true) => {
    if (!url) return '';
    
    // Handle YouTube Shorts URLs - Try different approach for audio controls
    if (url.includes('youtube.com/shorts/')) {
      const videoId = url.split('youtube.com/shorts/')[1].split('?')[0];
      // Simplified parameters to force controls visibility
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=${muted ? 1 : 0}&controls=1&rel=0&showinfo=0&fs=1&modestbranding=0`;
    }
    
    // Handle regular YouTube URLs
    if (url.includes('youtube.com/watch?v=')) {
      const videoId = url.split('v=')[1].split('&')[0];
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=${muted ? 1 : 0}&loop=1&playlist=${videoId}&controls=1&modestbranding=0&rel=0&showinfo=0&fs=1&cc_load_policy=0&iv_load_policy=3&autohide=0&enablejsapi=1&origin=${window.location.origin}`;
    }
    
    return url;
  };

  // Use sample video URL from config
  const sampleVideoUrl = appConfig.sampleVideo.url;
  // Use regular YouTube URL for better control visibility
  const embedUrl = getEmbedUrl(sampleVideoUrl, isMuted);

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  return (
    <section className="hero-video-section pb-5">
      <Container>
        <Row className="align-items-center">
          {/* Text Content - Left Side on Desktop (2/3 width) */}
          <Col lg={8} className="hero-text-col">
            <div className="hero-text-content">
              <h1 className="display-1">
                Your fantasy league <span className="text-gradient">RecapVid</span>
              </h1>
              <p className="lead">
                {appConfig.brand.description}
              </p>
              <div className="hero-cta">
                <Link to="/onboarding/platform" className="d-inline-block">
                  <Button 
                    className="btn-primary-gradient btn-lg"
                    style={{
                      fontSize: "1.1rem", 
                      fontWeight: "600",
                      padding: "16px 32px",
                      width: "auto"
                    }}
                  >
                    Get Started →
                  </Button>
                </Link>
              </div>
            </div>
          </Col>

          {/* Video Content - Right Side on Desktop (1/3 width) */}
          <Col lg={4} className="hero-video-col">
            <div className="iphone-frame-container">
              <div className="iphone-frame">
                <div className="iphone-screen">
                  <div className="iphone-video-container">
                    <iframe
                      width="100%"
                      height="100%"
                      src={embedUrl}
                      title="RecapVid Sample Video"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                      style={{ 
                        border: 'none',
                        borderRadius: '39px',
                        overflow: 'hidden'
                      }}
                    ></iframe>
                  </div>
                </div>
                {/* Custom Audio Toggle Button - Now inside the phone frame */}
                <div className="audio-toggle-phone-top-right">
                  <Button
                    variant="outline-light"
                    size="sm"
                    onClick={toggleMute}
                    className="audio-toggle-btn-icon"
                    title={isMuted ? 'Unmute Video' : 'Mute Video'}
                  >
                    <i className={`fas ${isMuted ? 'fa-volume-mute' : 'fa-volume-up'}`}></i>
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroVideoSection;
